export const ArrowDown = () => (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.5" d="M13 1L7 7L1 1" stroke="currentColor" strokeWidth="1.5"/>
    </svg> 
)